import { Component, Input, forwardRef, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'picker',
  templateUrl: 'picker.component.html',
  styleUrls: ['./picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PickerComponent),
      multi: true
    }
  ]
})

export class PickerComponent implements ControlValueAccessor {
  @Input() items: Array<any>;
  @Input('value') _value: any;
  @Input() asTime: boolean = false;
  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this._value;
  }
  
  set value(val) {
    this._value = val;    
    this.onChange(val);
  }

  constructor() { }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) { 
    this.onTouched = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  selectValue(value) {
    this.value = value;
  }

  getSelectedValue() {
    return this.value;
  }

}
